import React, { useState } from 'react'
import { Edit, Bell, LogOut } from 'lucide-react'
import PasswordUpdateForm from '../components/PasswordUpdateForm'
import Modal from '../../../components/common/Modal'
import { useVendorDashboard } from '../VendorDashboard'

const VendorSettings = () => {
  const { handleWithdrawRegistration } = useVendorDashboard()
  const [showChangePassword, setShowChangePassword] = useState(false)

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Settings</h3>
      
      <div className="bg-white dark:bg-slate-800 rounded-lg p-6 shadow-sm border border-gray-200 dark:border-gray-700">
        <h4 className="font-medium text-gray-900 dark:text-white mb-4">Account Actions</h4>
        <div className="space-y-4">
          <button className="w-full text-left p-4 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
            <div className="flex items-center">
              <Edit className="w-5 h-5 text-gray-400 mr-3" />
              <div>
                <div className="font-medium text-gray-900 dark:text-white">Edit Profile</div>
                <div className="text-sm text-gray-600 dark:text-gray-300">Update your company information</div>
              </div>
            </div>
          </button>
          
          <button className="w-full text-left p-4 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
            <div className="flex items-center">
              <Bell className="w-5 h-5 text-gray-400 mr-3" />
              <div>
                <div className="font-medium text-gray-900 dark:text-white">Notification Settings</div>
                <div className="text-sm text-gray-600 dark:text-gray-300">Manage your notification preferences</div>
              </div>
            </div>
          </button>
          
          <button 
            onClick={handleWithdrawRegistration}
            className="w-full text-left p-4 border border-error-200 dark:border-error-800 rounded-lg hover:bg-error-50 dark:hover:bg-error-900/20 transition-colors"
          >
            <div className="flex items-center">
              <LogOut className="w-5 h-5 text-error-400 mr-3" />
              <div>
                <div className="font-medium text-error-900 dark:text-error-100">Withdraw Registration</div>
                <div className="text-sm text-error-700 dark:text-error-300">Cancel your vendor registration</div>
              </div>
            </div>
          </button>

          {/* Change Password action (shows form inline when clicked) */}
          <div>
            <button
              onClick={() => setShowChangePassword(true)}
              className="w-full text-left p-4 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors flex items-center"
            >
              <div className="w-5 h-5 text-gray-400 mr-3">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-5 h-5"><path d="M12 15v2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path><path d="M17 11V9a5 5 0 10-10 0v2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
              </div>
              <div>
                <div className="font-medium text-gray-900 dark:text-white">Change Password</div>
                <div className="text-sm text-gray-600 dark:text-gray-300">Update your account password</div>
              </div>
            </button>
          </div>
        </div>
        <Modal isOpen={showChangePassword} onClose={() => setShowChangePassword(false)} title="Change Password">
          <PasswordUpdateForm />
        </Modal>
      </div>
    </div>
  )
}

export default VendorSettings

